import React from "react";
import "./RatingCard.css";

const RatingCard = ({ business }) => {
  const rating = business?.averageRating || 0;
  const reviews = business?.totalReviews || 0;

  return (
    <div className="rating-card">

      <div className="rating-header">

        <div>
          <h3>⭐ Customer Rating</h3>
          <p>Your overall customer satisfaction</p>
        </div>

        <span className="rating-badge">
          {rating.toFixed(1)}
        </span>

      </div>

      <div className="rating-content">

        <div className="rating-score">
          {rating.toFixed(1)}
        </div>

        <div className="rating-stars">
          ⭐⭐⭐⭐⭐
        </div>

        <h4>{reviews} Reviews</h4>

        <p>
          Keep providing quality food and service to improve your rating.
        </p>

      </div>

    </div>
  );
};

export default RatingCard;